import CreditMeter from "./credit_meter"
import UpgradeCreditsButton from "./upgrade_credits_button"
import { spentPercentage } from "./utils/credits"
import { CreditsBalance } from "shared/utils/credits"
import { Tier } from "./utils/interfaces"

import styles from "./credit_balance_bar.module.scss"

interface Props {
  balance: CreditsBalance
  tier: Tier
  onUpgrade: () => void
}

const CreditBalanceBar = ({ balance, tier, onUpgrade }: Props) => {
  const allotment = tier === "free" ? "free monthly credits" : "monthly credits"

  return (
    <div className={styles["credit-balance-bar"]}>
      <CreditMeter filled={spentPercentage(balance)}>
        <span className="body-caption">
          {balance.remaining} of {balance.monthly_total} {allotment} are left.
        </span>
      </CreditMeter>
      <UpgradeCreditsButton onClick={onUpgrade} />
    </div>
  )
}

export default CreditBalanceBar
